
export class EventMinTicketPriceAndSoldOutInformationDto {
  eventId: string;
  cheapestPrice: number;
  isSoldOut: boolean;
  numberOfTickets: number;
  numberOfSoldTickets: number;
  numberOfFreeTickets: number;
}
